
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delete-acc",
      function () {
        return require("private-next-pages/delete-acc.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delete-acc"])
      });
    }
  